import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { CustomerEditGet } from '../../../services/customer.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { CustomerItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
    selector: 'tt-business-co-on-boarding',
    templateUrl: './business-co-on-boarding.component.html',
    styleUrls: ['./business-co-on-boarding.component.css'],
    standalone: false
})
export class BusinessCoOnBoardingComponent implements OnInit {
    public customerButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.page!.cust_no ?? '' }];

    public customerSearchButtons: FormButton[] = [{ id: 'new', type: 'primary', icon: 'fas fa-plus', onClick: () => this.openNewCustomerModal?.() }];

    public page?: BusinessCoOnBoardingGet;

    public selectListCompanies: BusinesscoItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) { }


    private async loadPage() {
        this.page = (await this.datatask.Post(3250))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async retrieveCustomer() {
        if (!!this.page?.cust_no) {
            const response = (await this.datatask.Post(67, { cust_no: this.page.cust_no }))[0];

            this.page.cust_name = response?.cust_name;
            this.page.cust_address = response?.cust_address;
            this.page.valuta_id = response?.cust_order_valuta_id;
            this.page.org_no = response?.org_no;
            this.page.stockplace_name = response?.cust_name + ' ' + response?.postplace_name;
        }
    }

    public searchCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.page!.cust_name,
            custtype: 'C',
            lastselect: 'SEARCH'
        });
    }

    public onCustomerNameSelected(event?: CustomerItem) {
        if (!this.page) return;

        this.page.cust_no = !!event ? '' + event.item_id : '0';
        this.page.cust_name = event?.item_name ?? '';

        this.retrieveCustomer();
    }

    public async saveChanges() {
        if (!!this.page) {
            try {
                this.saving = true;

                const saveConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'businesscoonboarding_confirm_save',
                    type: 'danger'
                });

                if (saveConfirmed) {
                    const response = (await this.datatask.Post(3251, this.page))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public openNewCustomerModal?: () => unknown = async () => {
        if (!this.page) return;

        const submitted: (CustomerEditGet & { addContactsAfterNewCustomer: boolean }) | undefined = await this.modal.openStateDialog({
            state: 'customeredit',
            params: this.page.cust_no //'0'
        });

        if (submitted) {
            this.page.cust_no = '' + submitted.cust_no;
            this.page.cust_name = submitted.cust_name;
            this.page.cust_address = submitted.cust_address;
            this.page.valuta_id = submitted.cust_order_valuta_id;
            this.page.org_no = submitted.org_no;
            this.page.stockplace_name = submitted.cust_name + ' ' + submitted.postplace_name;
        }
    }

    private async init() {
        this.loadPage();
        this.loadCompanies();
    }

    ngOnInit() {
        this.init();
    }
}

interface BusinessCoOnBoardingGet {
    cust_no: string;
    cust_name: string;
    cust_address: string;
    org_no: string;
    valuta_id: string;
    stockplace_name: string;
    businessco_no_copy_from: string;
}
